import React, { useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  IconButton,
  Divider,
  Slide
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const cities = [
  'Hyderabad',
  'Bangalore',
  'Mumbai',
  'Delhi',
  'Chennai',
  'Pune',
  'Kolkata',
  'Ahmedabad'
];

const occupationTypes = [
  'Salaried',
  'Self-Employed',
  'Business',
  'Professional',
  'Other'
];

const HomeLoanModal = ({ open, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    city: '',
    hasPropertyIdentified: '',
    occupation: '',
    loanAmount: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      TransitionComponent={Transition}
      PaperProps={{
        sx: {
          borderRadius: 2,
          p: 1
        }
      }}
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        pb: 1,
        borderBottom: '1px solid #eee'
      }}>
        <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', color: '#d10000' }}>
          Apply for Home Loan
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <form onSubmit={handleSubmit}>
        <DialogContent sx={{ py: 3 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              required
              name="name"
              label="Applicant Name"
              variant="outlined"
              fullWidth
              value={formData.name}
              onChange={handleChange}
              size="small"
            />
            
            <Box sx={{ display: 'flex', gap: 2 }}>
              <TextField
                required
                name="phone"
                label="Phone Number"
                variant="outlined"
                fullWidth
                type="tel"
                value={formData.phone}
                onChange={handleChange}
                size="small"
              />
              
              <TextField
                required
                name="email"
                label="Email"
                variant="outlined"
                fullWidth
                type="email"
                value={formData.email}
                onChange={handleChange}
                size="small"
              />
            </Box>
            
            <FormControl fullWidth size="small" required>
              <InputLabel>City</InputLabel>
              <Select
                name="city"
                value={formData.city}
                label="City"
                onChange={handleChange}
              >
                {cities.map((city) => (
                  <MenuItem key={city} value={city}>
                    {city}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            
            <Box>
              <Typography variant="subtitle2" gutterBottom>
                Have you identified the property?
              </Typography>
              <RadioGroup
                row
                name="hasPropertyIdentified"
                value={formData.hasPropertyIdentified}
                onChange={handleChange}
              >
                <FormControlLabel value="yes" control={<Radio size="small" />} label="Yes" />
                <FormControlLabel value="no" control={<Radio size="small" />} label="No" />
              </RadioGroup>
            </Box>
            
            <FormControl fullWidth size="small" required>
              <InputLabel>Occupation Type</InputLabel>
              <Select
                name="occupation"
                value={formData.occupation}
                label="Occupation Type"
                onChange={handleChange}
              >
                {occupationTypes.map((type) => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            
            <TextField
              required
              name="loanAmount"
              label="Loan Amount (in Lacs)"
              variant="outlined"
              fullWidth
              type="number"
              value={formData.loanAmount}
              onChange={handleChange}
              size="small"
              inputProps={{ min: 1, step: 1 }}
            />
          </Box>
        </DialogContent>
        
        <Divider />
        
        <DialogActions sx={{ p: 2, justifyContent: 'space-between' }}>
          <Button onClick={onClose} color="inherit">
            Cancel
          </Button>
          <Button 
            type="submit" 
            variant="contained" 
            color="error"
            sx={{
              px: 4,
              '&:hover': {
                backgroundColor: '#b30000'
              }
            }}
          >
            Submit Application
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default HomeLoanModal;
